webpackJsonp([6],{

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shop_ItemView__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shop_CartView__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shop_IndexView__ = __webpack_require__(543);




__WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__["a" /* ViewFactory */].setRegistry({
    'ItemView': __WEBPACK_IMPORTED_MODULE_1__Shop_ItemView__["a" /* ItemView */],
    'CartView': __WEBPACK_IMPORTED_MODULE_2__Shop_CartView__["a" /* CartView */],
    'IndexView': __WEBPACK_IMPORTED_MODULE_3__Shop_IndexView__["a" /* IndexView */],
});


/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers_ModalHelper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Xelect_XelectComponent_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_ValidationMessage_ValidationMessage_vue__ = __webpack_require__(55);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var Action;
(function (Action) {
    Action[Action["AddItemToCart"] = 0] = "AddItemToCart";
    Action[Action["Checkout"] = 1] = "Checkout";
})(Action || (Action = {}));
var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
        this.itemId = "";
    }
    return ViewDataModel;
}());
var ItemView = /** @class */ (function (_super) {
    __extends(ItemView, _super);
    function ItemView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    ItemView.prototype.SetupVue = function () {
        var modalHelper;
        var v = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
            el: ".app",
            data: {
                sizes: this._viewData.sizes,
                model: {
                    itemId: this._viewData.itemId,
                    amount: 1,
                    size: this._viewData.sizes[0] ? this._viewData.sizes[0].value : "",
                },
                validationResults: {},
                images: this._viewData.images,
                currentImageUrl: this._viewData.images[0]
            },
            beforeMount: function () {
                modalHelper = new __WEBPACK_IMPORTED_MODULE_1__Helpers_ModalHelper__["a" /* ModalHelper */](this);
            },
            mounted: function () {
            },
            components: {
                XelectComponent: __WEBPACK_IMPORTED_MODULE_5__Components_Xelect_XelectComponent_vue__["a" /* default */],
                ValidationMessage: __WEBPACK_IMPORTED_MODULE_6__Components_ValidationMessage_ValidationMessage_vue__["a" /* default */]
            },
            methods: {
                increaseAmount: function () {
                    this.model.amount++;
                },
                decreaseAmount: function () {
                    if (this.model.amount <= 1) {
                        this.model.amount = 1;
                    }
                    else {
                        this.model.amount--;
                    }
                },
                addItemToCart: function () {
                    __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.AddItemToCart]), { contentType: "application/json", dataType: "json", method: "post", data: this.model })
                        .done(function (res) {
                        if (!res.isSuccess) {
                            v.validationResults = res.validationResults;
                            return;
                        }
                        modalHelper.getModal({
                            title: "Toode on lisatud ostukorvi",
                            //text: text,
                            buttons: [
                                {
                                    title: "Vormistan tellimuse",
                                    handler: function () {
                                        document.location.href = __WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.Checkout]);
                                    }
                                },
                                {
                                    title: "Jätkan ostlemist",
                                    default: true,
                                    handler: function () {
                                        modalHelper.hide();
                                    }
                                }
                            ]
                        });
                    });
                }
            }
        });
    };
    return ItemView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers_ModalHelper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Xelect_XelectComponent_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_ValidationMessage_ValidationMessage_vue__ = __webpack_require__(55);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var Action;
(function (Action) {
    Action[Action["Pay"] = 0] = "Pay";
    Action[Action["SetAmount"] = 1] = "SetAmount";
    Action[Action["GetEveryPayRequestData"] = 2] = "GetEveryPayRequestData";
})(Action || (Action = {}));
var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
    }
    return ViewDataModel;
}());
var CartView = /** @class */ (function (_super) {
    __extends(CartView, _super);
    function CartView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue(_this);
        return _this;
    }
    CartView.prototype.SetupVue = function (view) {
        var modalHelper;
        var v = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
            el: ".app",
            data: {
                processing: false,
                cart: this._viewData.cart,
                groupMembers: this._viewData.groupMembers,
                model: {
                    acceptTerms: false,
                    selectedGroupMemberId: ""
                },
                validationResults: {},
                paymentError: ""
            },
            beforeMount: function () {
                modalHelper = new __WEBPACK_IMPORTED_MODULE_1__Helpers_ModalHelper__["a" /* ModalHelper */](this);
            },
            mounted: function () {
            },
            components: {
                XelectComponent: __WEBPACK_IMPORTED_MODULE_5__Components_Xelect_XelectComponent_vue__["a" /* default */],
                ValidationMessage: __WEBPACK_IMPORTED_MODULE_6__Components_ValidationMessage_ValidationMessage_vue__["a" /* default */]
            },
            computed: {
                itemsCount: function () {
                    var count = 0;
                    for (var i = 0; i < this.cart.items.length; i++) {
                        count += this.cart.items[i].amount;
                    }
                    return count;
                }
            },
            methods: {
                increaseAmount: function (cartItemId) {
                    var _this = this;
                    var item = this.cart.items.find(function (x) { return x.id == cartItemId; });
                    if (item) {
                        var amount = item.amount + 1;
                        view._setAmount(cartItemId, amount)
                            .done(function (res) {
                            if (!res.isSuccess) {
                                if (res.validationResults && res.validationResults.Size) {
                                    modalHelper.getNotificationModal(res.validationResults.Size.errors[0].error);
                                }
                                return;
                            }
                            res.item.cartItem.defaultImageThumbnailUrl = item.defaultImageThumbnailUrl;
                            Object.assign(item, res.item.cartItem);
                            _this.updateSum(res.item);
                        });
                    }
                },
                decreaseAmount: function (cartItemId) {
                    var _this = this;
                    var item = this.cart.items.find(function (x) { return x.id == cartItemId; });
                    if (item) {
                        var amount = item.amount - 1;
                        if (amount <= 0) {
                            this.removeFromCart(cartItemId);
                            return;
                        }
                        view._setAmount(cartItemId, amount)
                            .done(function (res) {
                            if (!res.isSuccess) {
                                //v.validationResults = res.validationResults;
                                return;
                            }
                            res.item.cartItem.defaultImageThumbnailUrl = item.defaultImageThumbnailUrl;
                            Object.assign(item, res.item.cartItem);
                            _this.updateSum(res.item);
                        });
                    }
                },
                removeFromCart: function (cartItemId) {
                    var _this = this;
                    view._setAmount(cartItemId, 0)
                        .done(function (res) {
                        if (!res.isSuccess) {
                            //v.validationResults = res.validationResults;
                            return;
                        }
                        _this.cart.items = _this.cart.items.filter(function (x) { return x.id != cartItemId; });
                        _this.updateSum(res.item);
                    });
                },
                updateSum: function (sum) {
                    this.cart.priceTotal = sum.priceTotal;
                    this.cart.priceTotalWoVat = sum.priceTotalWoVat;
                    this.cart.vat = sum.vat;
                },
                everyPay: function () {
                    var _this = this;
                    __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.GetEveryPayRequestData]), {
                        contentType: "application/json",
                        dataType: "json",
                        method: "post",
                        data: {
                            groupMemberId: this.model.selectedGroupMemberId,
                            cartId: this.cart.id
                        }
                    })
                        .done(function (res) {
                        _this.paymentError = "";
                        if (!res.isSuccess) {
                            _this.paymentError = res.validationSummary;
                        }
                        else {
                            var data = res.item;
                            document.location.href = data.payment_link;
                        }
                    })
                        .always(function (x) {
                        _this.processing = false;
                    });
                }
            }
        });
    };
    CartView.prototype._setAmount = function (cartItemId, amount) {
        var data = {
            cartItemId: cartItemId,
            amount: amount
        };
        return __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.SetAmount]), {
            contentType: "application/json",
            dataType: "json",
            method: "post",
            data: data
        });
    };
    CartView.prototype._formSubmit = function (options) {
        var form = document.createElement("form");
        form.method = options.method;
        form.action = options.url;
        if (options.target) {
            form.target = options.target;
        }
        if (options.data) {
            for (var key in options.data) {
                if (options.data.hasOwnProperty(key)) {
                    var hiddenField = document.createElement("input");
                    hiddenField.type = "hidden";
                    hiddenField.name = key;
                    hiddenField.value = options.data[key];
                    form.appendChild(hiddenField);
                }
            }
        }
        document.body.appendChild(form);
        form.submit();
        form.remove();
    };
    return CartView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndexView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers_ModalHelper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_ValidationMessage_ValidationMessage_vue__ = __webpack_require__(55);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var Action;
(function (Action) {
    Action[Action["AddItemToCart"] = 0] = "AddItemToCart";
    Action[Action["GetItemDetail"] = 1] = "GetItemDetail";
    Action[Action["Checkout"] = 2] = "Checkout";
})(Action || (Action = {}));
var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
    }
    return ViewDataModel;
}());
var IndexView = /** @class */ (function (_super) {
    __extends(IndexView, _super);
    function IndexView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    IndexView.prototype.SetupVue = function () {
        var modalHelper;
        var v = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
            el: ".app",
            data: {
                item: {},
                showModal: false,
                itemValidationResults: {}
            },
            beforeMount: function () {
                modalHelper = new __WEBPACK_IMPORTED_MODULE_1__Helpers_ModalHelper__["a" /* ModalHelper */](this);
            },
            mounted: function () {
            },
            components: {
                ValidationMessage: __WEBPACK_IMPORTED_MODULE_5__Components_ValidationMessage_ValidationMessage_vue__["a" /* default */]
            },
            methods: {
                beginAddItemToCart: function (itemId) {
                    var _this = this;
                    __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.GetItemDetail]) + "?itemId=" + itemId, {
                        contentType: "application/json",
                        dataType: "json",
                        method: "get",
                    })
                        .done(function (res) {
                        if (res.availableSizes.length === 1) {
                            _this.addItemToCart({
                                itemId: itemId,
                                amount: 1,
                                size: res.availableSizes[0].value
                            });
                        }
                        else {
                            Object.assign(v.item, res);
                            v.itemValidationResults = {};
                            v.showModal = true;
                        }
                    });
                },
                addItemToCart: function (data) {
                    if (!data) {
                        data = {
                            itemId: v.item.id,
                            amount: 1,
                            size: v.item.size
                        };
                    }
                    __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.AddItemToCart]), {
                        contentType: "application/json",
                        dataType: "json",
                        method: "post",
                        data: data
                    })
                        .done(function (res) {
                        if (!res.isSuccess) {
                            if (v.showModal) {
                                v.itemValidationResults = res.validationResults;
                            }
                            else {
                                modalHelper.getNotificationModal(res.validationSummary);
                            }
                            return;
                        }
                        v.showModal = false;
                        modalHelper.getModal({
                            title: "Toode on lisatud ostukorvi",
                            //text: text,
                            buttons: [
                                {
                                    title: "Vormistan tellimuse",
                                    handler: function () {
                                        document.location.href = __WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.Checkout]);
                                    }
                                },
                                {
                                    title: "Jätkan ostlemist",
                                    default: true,
                                    handler: function () {
                                        modalHelper.hide();
                                    }
                                }
                            ]
                        });
                    });
                },
            }
        });
    };
    return IndexView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ })

},[540]);


// WEBPACK FOOTER //
// js/page/shop.bundle.js